window.initMap = function(endpoint, cat, q) {
	GoogleMaps.init(endpoint, cat, q);
}

let event = new CustomEvent('finish', {
	detail: {
		isLoading: false
	}
  });

const googleMapMaxZoom = 16;

const GoogleMaps = {

	details: document.getElementById('mapDetails'),
	detailsClose: document.getElementById('mapDetailsClose'),
	markers: [],
	bounds: null,

	icon: {
		path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
		fillColor: '#C41230',
		fillOpacity: .8,
		strokeWeight: 0,
		scale: .5
	},

	iconSecondary: {
		path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
		fillColor: '#282525',
		fillOpacity: .8,
		strokeWeight: 0,
		scale: .5
	},

	iconActive: {
		path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
		fillColor: '#282525',
		fillOpacity: 1,
		strokeWeight: 0,
		scale: .6
	},

    init: function(endpoint, cat, q) {

		var conf = document.getElementById('map'),
            query = (q) ? q : conf.dataset['q'],
            category = (cat) ? cat : conf.dataset['cat'],
			// query = q;
			// category = cat;
			jsonEndpoint = (endpoint) ? endpoint : conf.dataset['endpoint'];
		
		if (category !== '') {
			endpoint = jsonEndpoint.split('.');
			jsonEndpoint = endpoint[0] +'/'+ category +'.json';
		}

		// console.log('map.js init', cat, q, endpoint);

        let map = new google.maps.Map(document.getElementById("map"), {
            center: { lat: 38.1792258, lng: -95.1894384 },
            zoom: 5,
		    mapId: 'ebb7cbd528325a63',
			maxZoom: googleMapMaxZoom,
			previousZoom: null
        });
        
		// console.log('cat', category, jsonEndpoint);
		axios.get(jsonEndpoint, { params: { q: query } })
			.then((response) => {
				// console.log('resp', response);
				var i = 0;
				this.markers = [];

				//disable loading spinner
				//set alpine variable isLoading to false;
				// console.log(window.utils);
				// document.querySelectorAll('[x-data]').forEach(el => {
					
				// 	const alpComp = el.__x.getUnobservedData();
				// 	if (alpComp.activeView == 'map') {
				// 		console.log(alpComp);
				// 		alpComp.isLoading = false;
				// 		// el.__x.setUnobservedData('isLoading', false);
				// 		console.log(el.__x.getUnobservedData());

				// 	}
				// });
				window.dispatchEvent(event);
				response.data.data.forEach(proj => {
					// console.log('project', proj);
					if(proj.locationMap.lat) {
						let contentString = (proj.thumb) ? '<a href="'+ proj.url +'" class="cursor-zoom-in"><img src="'+ proj.thumb +'" alt="'+ proj.title +'" class="block w-full sm:h-40 mb-4 object-cover animate__animated animate__fadeIn" /></a>' : '';
                        contentString += '<div class="p-4 animate__animated animate__fadeIn">';
						if (proj.industry) contentString += '<h5 class="text-slate-500 tracking-widest">'+ proj.industry +'</h5>';
						contentString += '<h4 class="mb-4">'+ proj.title +'</h4>' +
								'<p><a target="_blank" href="'+ proj.url +'" class="cta--link__underline inline-block font-sans font-bold text-dcired pb-1 mt-6 transition">Learn more</a></p>' +
								'</div>';

                        const infowindow = new google.maps.InfoWindow({
                            content: contentString,
                        });

						let marker = new google.maps.Marker({
							position: proj.locationMap,
							map,
							title: proj.title,
							animation: google.maps.Animation.FADE,
							icon: this.icon,
							isPrimary: proj.isPrimary || false
						});
						if (proj.isPrimary === false) {
							marker.setIcon(this.iconSecondary);
						}

						// handle click on marker
						if (proj.type !== 'singleMarker') {
							marker.addListener("click", () => {
								//record current zoom level
								this.previousZoom = map.zoom;

								var _this = this;
								this.resetIcons(map);
								marker.setIcon(this.iconActive);
								
								map.setZoom(googleMapMaxZoom);
								map.setCenter(marker.getPosition());
								this.details.innerHTML = contentString;
								this.details.classList.replace('opacity-0', 'opacity-100');
								this.detailsClose.classList.replace('hidden', 'block');
								this.detailsClose.classList.replace('opacity-0', 'opacity-100');
								this.detailsClose.addEventListener('click', function() {
									_this.closeInfo(map);
								});
							});
						}

						// map.fitBounds(bounds);
						this.markers[i] = marker;
						i++;
						
						//check for children and load them too
						if (proj.children) {
							// console.log('has children');
							var _this = this;
							proj.children.forEach(function(child) {
								let marker = new google.maps.Marker({
									position: child.locationMap,
									map,
									title: child.title,
									animation: google.maps.Animation.FADE,
									icon: _this.icon,
									isPrimary: child.isPrimary || false
								});
								if (child.isPrimary === false) {
									marker.setIcon(_this.iconSecondary);
								}

								_this.markers[i] = marker;
								i++;
							});
						}

						setTimeout( () => { this.setBounds(map) }, 250);
					}
				});

				google.maps.event.addListener(map,'click', function () {
					GoogleMaps.resetIcons(map);
					GoogleMaps.closeInfo(map);
				});
			})
			.catch((error) => {
				console.log(error);
		    });
		// }
		  
    },

	setBounds: function(map) {
		var bounds = new google.maps.LatLngBounds();
		for (var x = 0; x < this.markers.length; x++) {
			bounds.extend(this.markers[x].getPosition());
		}
		map.fitBounds(bounds);
	},

	closeInfo: function(map) {
		this.details.classList.replace('opacity-100', 'opacity-0');
		this.details.innerHTML = '';
		this.detailsClose.classList.replace('block', 'hidden');
		this.detailsClose.classList.replace('opacity-100', 'opacity-0');
		this.resetIcons(map);
	},

	resetIcons: function(map) {
		for (var x = 0; x < this.markers.length; x++) {
			if (this.markers[x].isPrimary === false && window.location.pathname.split('/')[1] == 'locations') {
				this.markers[x].setIcon(this.iconSecondary);
			} else {
				this.markers[x].setIcon(this.icon);
			}
		}
		if (this.previousZoom != null) {
			map.setZoom(this.previousZoom);
		} else {
			this.setBounds(map);
		}
	},

}

export default GoogleMaps;


